import React from "react";
import ReactModal from "react-modal";
import cx from "classnames";

const styles = {
  overlay: {
    zIndex: 10,
    backgroundColor: "rgba(255, 255, 255, 0.85)",
  },
};

const Modal = ({ children, isOpen, isFull, className }) => (
  <ReactModal
    isOpen={isOpen}
    className={cx("modal", { "modal--full": isFull }, className)}
    portalClassName="ReactModalPortal legacy"
    contentLabel="Modal"
    style={styles}
    ariaHideApp={false}
  >
    <div className="modal__body">{children}</div>
  </ReactModal>
);

export default Modal;
